export default function About() {
  return (
    <section id="about" className="py-20 lg:py-32 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="text-xs font-bold text-gray-600 uppercase tracking-widest mb-6">ABOUT REGAL SPRINTER</div>
          <div className="lg:w-4/5">
            <p className="text-2xl lg:text-3xl xl:text-4xl text-gray-900 leading-relaxed font-light">
              Experience the perfect blend of <strong className="font-bold">luxury and affordability</strong> with Regal Sprinter's high-end transportation services. Our premium <strong className="font-bold">Mercedes-Benz fleet</strong> accommodates up to <strong className="font-bold">10 passengers</strong> with ample luggage space, ensuring comfort for corporate events, private tours, and airport transfers throughout <strong className="font-bold">Greater Houston</strong>.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="text-center lg:text-left">
            <div className="text-6xl lg:text-7xl xl:text-8xl font-bold text-gray-900 mb-3">10+</div>
            <div className="text-base lg:text-lg text-gray-600">Passenger Capacity</div>
          </div>
          
          <div className="text-center lg:text-left">
            <div className="text-6xl lg:text-7xl xl:text-8xl font-bold text-gray-900 mb-3">24/7</div>
            <div className="text-base lg:text-lg text-gray-600">Available Service</div>
          </div>
          
          <div className="text-center lg:text-left">
            <div className="text-6xl lg:text-7xl xl:text-8xl font-bold text-gray-900 mb-3">100%</div>
            <div className="text-base lg:text-lg text-gray-600">Professional Drivers</div>
          </div>
          
          <div className="text-center lg:text-left">
            <div className="text-6xl lg:text-7xl xl:text-8xl font-bold text-gray-900 mb-3">5★</div>
            <div className="text-base lg:text-lg text-gray-600">Customer Rating</div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Safety First</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              All our vehicles are regularly maintained and fully insured. Our professional drivers undergo rigorous background checks and training.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Always On Time</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Punctuality is our priority. We track flights and traffic to ensure you arrive at your destination on schedule, every time.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Support</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Our dedicated customer service team is available around the clock to assist with bookings, changes, or any questions you may have.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
